import script from "./AllergyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergyForm.vue?vue&type=script&setup=true&lang=ts"

import "./AllergyForm.vue?vue&type=style&index=0&id=1a155eec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a155eec"]])

export default __exports__